import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "layout-row layout-row-full"
}
const _hoisted_2 = { class: "layout-row" }

import { computed, onBeforeMount, watch, Ref, ref } from "vue";
import { DeviceDisplayType } from "../../enums";
import { ISectionComponent } from "../../interfaces";
import { useRenderStore } from "../../stores/renderStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionComponent',
  props: ["component"],
  setup(__props) {

const renderStore = useRenderStore();

const props = __props;
const component = ref(props.component) as Ref<ISectionComponent>;

const sectionBgImage = ref(component.value.customData.backgroundImage);
const sectionBgColor = ref(component.value.styles.backgroundColor);
const sectionPaddingBottom = ref(component.value.customData.bottomPadding);
const sectionPaddingTop = ref(component.value.customData.topPadding);
const sectionSpacingSize = ref(component.value.customData.spacingSize);
const sectionContainerSize = ref(component.value.customData.containerSize);
const isMobile = ref(false);

const showSection = computed(() => {
    if (renderStore.builderMode) return true;

    if (component.value.customData.deviceDisplay === DeviceDisplayType.All) {
        return true;
    }
    else if (component.value.customData.deviceDisplay === DeviceDisplayType.Mobile && isMobile.value) {
        return true;
    }
    else if (component.value.customData.deviceDisplay === DeviceDisplayType.Desktop && !isMobile.value) {
        return true;
    }

    return false;
});

const updateBackgroundImage = () => {
    if (isMobile.value && component.value.customData.useMobileBackgroundImage) {
        sectionBgImage.value = component.value.customData.mobileBackgroundImage;
    } else {
        sectionBgImage.value = component.value.customData.backgroundImage;
    }
};

const updateIsMobile = () => {
    isMobile.value = window.innerWidth < 768;
    updateBackgroundImage();
};

window.addEventListener("resize", updateIsMobile);

onBeforeMount(() => {
    if (component.value.customData.useMobileBackgroundImage) {
        updateIsMobile();
    }
});

watch(() => component.value.styles.backgroundColor, () => {
    sectionBgColor.value = component.value.styles.backgroundColor;
});

watch(() => component.value.customData.backgroundImage, () => {
    sectionBgImage.value = component.value.customData.backgroundImage;
});

watch(() => component.value.customData.spacingSize, () => {
    sectionSpacingSize.value = component.value.customData.spacingSize;
});

watch(() => component.value.customData.containerSize, () => {
    sectionContainerSize.value = component.value.customData.containerSize;
});

watch(() => component.value.customData.bottomPadding, () => {
    sectionPaddingBottom.value = component.value.customData.bottomPadding;
});

watch(() => component.value.customData.topPadding, () => {
    sectionPaddingTop.value = component.value.customData.topPadding;
});

return (_ctx: any,_cache: any) => {
  return (_unref(renderStore).hasOneSectionAndIsModalEmbed)
    ? _renderSlot(_ctx.$slots, "children", { key: 0 })
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (showSection.value)
          ? (_openBlock(), _createElementBlock("section", {
              key: 0,
              class: _normalizeClass(["section-container", [component.value.styles.cssClass,
        sectionSpacingSize.value && `spacing-${sectionSpacingSize.value}`]]),
              style: _normalizeStyle([
            sectionBgImage.value ? { backgroundImage: `url(${sectionBgImage.value})` } : '',
            sectionBgColor.value ? { backgroundColor: sectionBgColor.value } : '',
            sectionPaddingBottom.value ? { 'padding-bottom': sectionPaddingBottom.value + 'px', } : '',
            sectionPaddingTop.value ? { 'padding-top': sectionPaddingTop.value + 'px', } : ''
        ])
            }, [
              (component.value.styles.fullWidth)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "children")
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(sectionContainerSize.value ? `layout-container-${sectionContainerSize.value}` : 'layout-container')
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "children")
                    ])
                  ], 2))
            ], 6))
          : _createCommentVNode("", true)
      ], 64))
}
}

})